import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { RealexTabState } from 'src/components/TopUpProcedure/RealexForm/RealexTab.state';
import {
    ErrorMessage,
    PayButton,
    PayButtonText,
    SuccessMessage,
} from 'src/components/TopUpProcedure/RealexForm/RealexTab.style';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { RealexFrame } from 'src/components/TopUpProcedure/RealexForm/RealexFrame';
import { useAppStateContext } from 'src/AppState/AppState';
import { PaymentAdditionsNew } from 'src/components/CustomersBar/CustomerTab/BankingTab/components/PaymentsAdditionsNew';
import { formatAmountWithCurrency } from 'src_common/common/amount/website-money/currency';
//@ts-expect-error
import ImmutablePropTypes from 'react-immutable-proptypes';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';
import { useCommon } from 'src/AppState/Common';

interface PropsType {
    customerId: number;
    permissionGrants: ImmutablePropTypes.map;
    onQueryAudits: () => void;
}
export const RealexTab = observer(
    'RealexTab',
    ({ customerId, permissionGrants, onQueryAudits }: PropsType): JSX.Element => {
        const { models, sdkStaff } = useAppStateContext();
        const common = useCommon();
        const [stateAutoMap] = useState(
            () =>
                new AutoMap(
                    (customerId: number) =>
                        new RealexTabState(sdkStaff, models, customerId, permissionGrants, common, onQueryAudits)
                )
        );

        const state = stateAutoMap.get(customerId);

        return (
            <>
                <Input
                    dataTest='deposit-amount-input'
                    maxLength={10}
                    placeholder='0.00'
                    formInputState={state.depositAmount}
                    onChange={state.onChange}
                    label='Amount'
                />

                <PaymentAdditionsNew
                    value={state.depositAmount.value}
                    currency={state.getCurrency}
                    onChange={state.handleAdditionsChange}
                    handleActionOnInput={state.handleClear}
                />

                <ErrorMessage
                    isError={state.errorMessage !== null}
                    data-test='error-message'
                >
                    {state.errorMessage}
                </ErrorMessage>
                <SuccessMessage
                    isSuccess={state.successMessage === true}
                    data-test='success-message'
                >
                    Payment has been successfully processed
                </SuccessMessage>

                <table>
                    <tbody>
                        <tr data-test='deposit-form-current-balance'>
                            <th>Current balance:</th>
                            <td>{formatAmountWithCurrency(state.getCurrency, state.getBalance)}</td>
                        </tr>
                        <tr data-test='deposit-form-withdrawable-balance'>
                            <th>Withdrawable balance:</th>
                            <td>{formatAmountWithCurrency(state.getCurrency, state.getWithdrawableBalance)}</td>
                        </tr>
                        <tr data-test='deposit-form-new-balance'>
                            <th>New balance:</th>
                            <td>{formatAmountWithCurrency(state.getCurrency, state.newBalance)}</td>
                        </tr>
                    </tbody>
                </table>
                <PayButton
                    disabled={
                        state.isEmptyAmountInput ||
                        state.areMissingFieldsForBillingInfoRealex() ||
                        state.getPermission()
                    }
                    onClick={state.confirmationTopUp}
                    type='submit'
                >
                    <PayButtonText
                        isDisabled={
                            state.isEmptyAmountInput ||
                            state.areMissingFieldsForBillingInfoRealex() ||
                            state.getPermission()
                        }
                    >
                        Top Up
                    </PayButtonText>
                </PayButton>

                {state.formParams !== undefined &&
                state.formParams.formData.data !== null &&
                state.isIframeOpen === true ? (
                    <RealexFrame
                        key={state.formParams.formData.data.SHA1HASH}
                        formData={state.formParams.formData.data}
                        formActionUrl={state.formParams.formActionUrl}
                        type={state.formParams.type}
                        setDepositFinalView={state.setDepositFinalView}
                        onCancel={state.onCancel}
                    />
                ) : null}
            </>
        );
    }
);
